import React from 'react';
import jwtEncode from "jwt-encode";
import { applicationId, CHANNEL_ID, SSO_URL } from '../../env'

const Login = () => {
    const payload = {
        origin: window.location.origin,
        redirectUri: window.location.pathname,
        applicationId,
    };

    const referrerUrlParam = jwtEncode(payload, "");

    return (
        <>
            <div className="sso-parent">
                <iframe
                    src={`${SSO_URL}/gateway/web/${CHANNEL_ID}?referrer=${referrerUrlParam}`}
                    title="Simulanis SSO Admin"
                    style={{ width: "100%", height: "100vh" }}
                />
            </div>
        </>
    )
}

export default Login
